export default __webpack_public_path__ + "static/media/SIMSUN.88854ac0.ttf";